import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core'
import { TextField, Button } from '@prototype'
import Table from '@tables/table'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'

const initialState = {
    name: '',
    startAt: '',
    endAt: '',
    eventID: '',
    isSentAward: false,
    isExpired: false,
    currency: null,
    dialogOpen: false,
    isNotEmptyData: false,
}

const COMPONENT_GROUP = 'event_prize';

class EventPrizeDetailDragonTigerBoardDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EventPrizeDetailDragonTigerBoardDialog', options)
        }
        this.state = initialState
    }

    dragonColumns = [
        { field: 'rank' },
        { field: 'account' },
        { field: 'origin_account' },
        { field: 'award', type: 'currency' },
        { field: 'total_bet', type: 'currency' },
    ]

    tigerColumns = [
        { field: 'rank' },
        { field: 'account' },
        { field: 'origin_account' },
        { field: 'award', type: 'currency' },
        { field: 'game_name' },
        { field: 'rate', type: 'number' },
    ]

    sentAwardColumns = [
        { field: 'pf_sub_pf_id' },
        { field: 'pf_account' },
        { field: 'origin_account' },
        { field: 'type_display' },
        { field: 'award_id' },
        { field: 'pay_money', title: utils.t('award', 'EventPrizeDetailDragonTigerBoardDialog'), type: 'currency' },
        { field: 'money', type: 'currency' },
        { field: 'total_bet', type: 'currency' },
        { field: 'bet_record_id' },
        { field: 'created_at', type: 'datetime' },
        { field: 'updated_at', type: 'datetime' },
        {
            field: 'is_success',
            render: (rowData) => (rowData['award_id'] ? this.t('yes') : this.t('no')),
        },
    ]

    options = {
        export: false
    }

    componentDidMount() {
        this.props.onRef(this)
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(eventID) {
        this.queryDragonTigerBoardData(eventID)
    }

    queryDragonTigerBoardData(eventID) {
        utils.apiRequest(
            'get',
            API.DRAGON_TIGER_BOARD_DETAIL,
            {
                event_id: eventID,
            },
            (data) => {
                this.setState({
                    // eventType: MISC.EVENT_DRAGON_TIGER_BOARD,
                    name: data['event_name'],
                    currency: data['currency'],
                    startAt: data['start_at'],
                    endAt: data['end_at'],
                    eventID: data['event_id'],
                    isSentAward: data['is_send_award'],
                    isExpired: data['is_expired'],
                    dialogOpen: true,
                    isNotEmptyData: !!data['dragon_ranking']?.length || !!data['tiger_ranking']?.length,
                })

                // this.updateTableColumnTitle(data['currency'])

                if (data['is_send_award']) {
                    this.queryDragonTigerBoardAwardData(eventID)
                } else {
                    data['dragon_ranking'].forEach(elem=>{
                        elem['pay_money'] *= utils.getCurrencyRate(data['currency'])
                        elem['total_bet'] *= utils.getCurrencyRate(data['currency'])
                    })
                    data['tiger_ranking'].forEach(elem=>{
                        elem['pay_money'] *= utils.getCurrencyRate(data['currency'])
                    })
                    this.dragonTable.SetData(data['dragon_ranking'].sort((a, b) => b['pay_money'] - a['pay_money']))
                    this.tigerTable.SetData(data['tiger_ranking'].sort((a, b) => b['pay_money'] - a['pay_money']))
                }
            },
            (_err) => {},
            true
        )
    }

    queryDragonTigerBoardAwardData(eventID) {
        utils.apiRequest(
            'get',
            API.DRAGON_TIGER_BOARD_AWARD_LIST,
            {
                event_id: eventID,
            },
            (data) => {
                const tableData = []
                Object.entries(data).forEach(([_key, arr]) => {
                    if (Array.isArray(arr))
                        arr.forEach((elem) => {
                            if (!elem['award_id']) {
                                elem['money'] = elem['award_money']
                                // elem['total_bet'] = 0
                            }
                            elem['type_display'] = this.t(`Event.${elem['type']}`)
                            elem['pf_sub_pf_id'] = utils.getSubPlatformName(elem['pf_sub_pf_id'])
                            elem['pay_money'] *= utils.getCurrencyRate(elem['currency'])
                            elem['money'] *= utils.getCurrencyRate(elem['currency'])
                            elem['total_bet'] *= utils.getCurrencyRate(elem['currency'])
                            tableData.push(elem)
                        })
                })

                this.sentAwardTable.SetData(tableData)
            },
            (_err) => {},
            true
        )
    }

    updateTableColumnTitle() {
        this.dragonColumns.find((elem) => elem.field === 'award').title = this.t('award')
        this.tigerColumns.find((elem) => elem.field === 'award').title = this.t('award')
        this.sentAwardColumns.find((elem) => elem.field === 'money').title = this.t('money')
        this.dragonTable && this.dragonTable.setColumns()
        this.tigerTable && this.tigerTable.setColumns()
        this.sentAwardTable && this.sentAwardTable.setColumns()
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} fullWidth maxWidth="lg">
                <DialogTitle>{this.t('view')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField className={this.props.classes.textField} readOnly label={this.t('name')} value={this.state.name} />
                            <TextField
                                className={this.props.classes.textField}
                                readOnly
                                label={this.t('currency')}
                                value={this.t(`Currency.${this.state.currency}`)}
                            />
                            <TextField
                                className={this.props.classes.dateRangeTextField}
                                readOnly
                                label={this.t('datetimeRange')}
                                value={`${utils.unixToDateTime(this.state.startAt)} ~ ${utils.unixToDateTime(this.state.endAt)}`}
                            />
                            <TextField
                                className={this.props.classes.textField}
                                readOnly
                                label={this.t('isSentAward')}
                                value={this.state.isSentAward ? this.t('yes') : this.t('no')}
                            />
                            { !this.state.isSentAward && this.state.isNotEmptyData && (this.props.auth.isSuperUser || this.props.auth.isAdmin) && (
                                <Button
                                    // className={this.props.classes.button}
                                    value={this.t('sendAward')}
                                    onClick={() => {
                                        this.confirmDialog.OpenDialog({
                                            type: 'info',
                                            msg: this.t('confirmSendAwardMsg'),
                                            confirmParams: {
                                                id: this.state.eventID,
                                            },
                                            confirm: (params) => {
                                                utils.apiRequest('post', `${API.DRAGON_TIGER_BOARD_SEND_AWARD}/${params.id}`, {}, (_data) => {
                                                    this.queryDragonTigerBoardData(params.id)
                                                    if (this.props.confirmCallback) {
                                                        this.props.confirmCallback()
                                                    }
                                                    this.confirmDialog.closeDialog()
                                                })
                                            },
                                        })
                                    }}
                                    disabled={!this.state.isExpired}
                                />
                            )}
                        </Grid>
                        {this.state.isSentAward ? (
                            <Grid item xs={12}>
                                <Table
                                    ownerName="EventPrizeDetailDragonTigerBoardDialog"
                                    columns={this.sentAwardColumns}
                                    options={{
                                        export: this.options.export,
                                        orderIdx: 3,
                                        orderDirection: 'desc',
                                    }}
                                    onRef={(ref) => (this.sentAwardTable = ref)}
                                />
                            </Grid>
                        ) : (
                            <React.Fragment>
                                <Grid item xs={6}>
                                    <Table
                                        ownerName="EventPrizeDetailDragonTigerBoardDialog"
                                        columns={this.dragonColumns}
                                        options={{
                                            export: this.options.export,
                                            showTitle: true,
                                        }}
                                        title={this.t('dragonBoard')}
                                        onRef={(ref) => (this.dragonTable = ref)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Table
                                        ownerName="EventPrizeDetailDragonTigerBoardDialog"
                                        columns={this.tigerColumns}
                                        options={{
                                            export: this.options.export,
                                            showTitle: true,
                                        }}
                                        title={this.t('tigerBoard')}
                                        onRef={(ref) => (this.tigerTable = ref)}
                                    />
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button value={this.t('confirm')} onClick={() => this.closeDialog()} />
                </DialogActions>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        select: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        dateRangeTextField: {
            margin: theme.spacing(1),
            width: '360px',
        },
        button: {
            margin: theme.spacing(1),
        },
    }
}

EventPrizeDetailDragonTigerBoardDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    auth: PropTypes.object.isRequired,
    isSuperUser: PropTypes.bool,
    isAdmin: PropTypes.bool,
}

export default hoc(styles)(EventPrizeDetailDragonTigerBoardDialog)
